// Add your custom JS here

// desktop hamburger menu item on click
function desktopHamburgerMenuItemClick() {
  const wrapperNavbar = document.querySelector('#wrapper-navbar');
  const customHumburgerItem = document.querySelector('.custom-humburger-item');
  const mainsubmenu = customHumburgerItem.querySelector('.mega-sub-menu');
  const closeMainHumburgerMenu = customHumburgerItem.querySelector('.close-main-humburger-menu');

  customHumburgerItem.addEventListener('click', (el) => {
    mainsubmenu.classList.add('active-custom');
    wrapperNavbar.style.mixBlendMode = 'normal';
    console.log('click open button customHumburgerItem');
    el.stopPropagation();
  });

  document.addEventListener('click', (el) => {
    const tempMainsubmenu = customHumburgerItem.querySelector('.mega-sub-menu');
    if (tempMainsubmenu.classList.contains('active-custom')) {
      const isOutside = !el.target.closest('.mega-sub-menu');
      if (isOutside) {
        mainsubmenu.classList.remove('active-custom');
        wrapperNavbar.style.mixBlendMode = 'difference';
        el.stopPropagation();
      }
    }
  });

  closeMainHumburgerMenu.addEventListener('click', (el) => {
    mainsubmenu.classList.remove('active-custom');
    wrapperNavbar.style.mixBlendMode = 'difference';
    el.stopPropagation();
  });
}
desktopHamburgerMenuItemClick();

// hamburger menu to add title style for single links
function desktopHamburgerMenuTitleLinks() {
  const customHumburgerItem = document.querySelector('.custom-humburger-item');
  const widgetsNavMenuArray = customHumburgerItem.querySelectorAll('.widget_nav_menu');
  widgetsNavMenuArray.forEach((el) => {
    const megaBlockTitle = el.querySelector('.mega-block-title');

    if (!megaBlockTitle) {
      el.classList.add('its-like-title-link-class');
    }
  });
}
desktopHamburgerMenuTitleLinks();

// hide header menu not from home page
function hideHeaderMenuNotFromHomePage() {
  !document.querySelector('.home') ? document.querySelector('.header-category-menu-class').style.display = 'none' : null;
  window.innerWidth >= 768 ? document.querySelector('.header-category-menu-class').style.display = 'none' : null;
}
hideHeaderMenuNotFromHomePage();

// add anchor to heading menu
// function addAnchorToHeadingMenu() {
//   const menuHeaderCategoryMenuLinks = document.querySelectorAll('#menu-header-category-menu .menu-item a');
//   console.log('menuHeaderCategoryMenuLinks: ', menuHeaderCategoryMenuLinks);
//   menuHeaderCategoryMenuLinks.forEach((el) => {
//     el.classList.add('anchor');
//   }); 
// }
// document.addEventListener('DOMContentLoaded', addAnchorToHeadingMenu);

// page scrolling sticky menu
function addScrollingStickyMenu() {
  const wrapperNavbar = document.querySelector('#wrapper-navbar');
  if (wrapperNavbar) {
    const mainNav = wrapperNavbar.querySelector('#main-nav');
    if (mainNav) {
      window.addEventListener('scroll', () => {
        if (window.pageYOffset > 260) {
          mainNav.classList.add('active-scroll');
        } else {
          mainNav.classList.remove('active-scroll');
        }
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', addScrollingStickyMenu);
